<div class="container-fluid">

<!-- ==================== DESBLOQUEAR CUANDO ESTE EL AGENTE LISTO =====================
<div class="chat-floating"  [class.open]="boolmsg"  [class.closed]="!boolmsg" *ngIf="strUsuario">
    <div class="chat-header">
        <div class="row">
            <div class="col-6 fw-bold">Asistente</div>
                <div class="col-6  d-flex align-items-center justify-content-end">
                    <div class="h-100"  (click)="fnCambiarMsg()">
                        <i class="fa-solid fa-window-minimize d-flex align-items-center"></i>
                    </div>
                </div>
            </div>
        </div>
    <div class="chat-body">
        <iframe [src]="chatUrl" width="100%" height="100%" frameborder="0">
        </iframe>
    </div>
    </div> -->



<!-- <div class="col-12 px-0 d-flex align-items-end floating-buttons" id="iconoFijo"> -->
    <div id="iconoFijo" class="floating-buttons d-inline-flex align-items-end px-0">
    <span *ngIf="!strUsuario || strUsuario==undefined || strUsuario==''"
        class=" rounded-circle shadow btn bgMenu p-4 position-relative" (click)="fnCambiarMenu()">
        <div class="d-flex flex-column position-absolute top-50 start-50 translate-middle">
            <div class="position-relative">
                <div [@rotateIcon]="boolMenu ? 'rotatedLeft' : 'initial'">
                    <i class="fa-solid fa-minus fs-4 position-absolute top-50 start-50 translate-middle"></i>
                </div>
                <!-- Segundo icono: Desaparece -->
                <i class="fa-solid fa-minus fs-4 position-absolute top-50 start-50 translate-middle"
                    [@disappearIcon]="boolMenu ? 'hidden' : 'visible'"></i>
                <div [@rotateIcon]="boolMenu ? 'rotatedRight' : 'initial'" class="">
                    <i class="fa-solid fa-minus fs-4 position-absolute top-50 start-50 translate-middle"></i>
                </div>
            </div>
        </div>
    </span>


    <!--============= Debe de funcionar cuando este listo el agente ============= -->
   <!--   <span *ngIf="strUsuario"
      [class.d-none]="boolmsg"  class=" rounded-circle shadow btn bgMenu p-4 position-relative" (click)="fnCambiarMsg()">
        <div class="d-flex flex-column position-absolute top-50 start-50 translate-middle">
            <div class="position-relative">
                <div>
                    <i class="fa-solid fa-comments fs-4 position-absolute top-50 start-50 translate-middle"></i>
                </div>
            </div>
        </div>
    </span> -->











    <!-- Aplica la animación al contenedor del menú -->
    <div class="" [@menuAnimation]="boolMenu ? 'visible' : 'hidden'" [ngClass]="boolMenu ? 'fadein' : 'fadeout'"
        [ngClass]="{'d-flex':boolMenu,'d-none':!boolMenu}">
        <ng-container *ngIf="!boolLogin && (!strUsuario || strUsuario==undefined || strUsuario=='')">
            <span class="rounded-circle shadow btn clsIconMenu ms-2 ball d-flex flex-column" matTooltip="Colaborador"
                [routerLink]="['/tiendaproducto/login']" (click)="boolMenu = false">
                <i class="p-0 bi bi-person-fill-lock fs14"></i>
            </span>
            <span class="rounded-circle shadow btn clsIconTienda ms-2 ball" matTooltip="Tienda en línea"
                [routerLink]="['/tienda']" (click)="boolMenu = false">
                <i class="bi bi-bag-fill fs14"></i>
            </span>
        </ng-container>

        <ng-container *ngIf="boolLogin && (!strUsuario || strUsuario==undefined || strUsuario=='')">
            <span class="rounded-circle shadow btn clsIconTienda ms-2 ball" matTooltip="Tienda en linea"
                [routerLink]="['/tienda']">
                <i class="bi bi-bag-fill fs14"></i>
            </span>
            <span class="rounded-circle shadow btn clsIconMenu ms-2 ball" matTooltip="Nuevo pedido"
                [routerLink]="[urlHome]">
                <i class="p-0 bi-house-fill fs14"></i>
            </span>
        </ng-container>
    </div>
</div>
<div class="col-12 position-relative floating-buttons" *ngIf="!strUsuario || strUsuario==undefined || strUsuario==''">
    <div class="position-absolute bottom-0 end-0">
        <div class="d-flex flex-column ">
            <a href="https://api.whatsapp.com/send?phone=524777296302&amp; text=Hola, contacto desde el sitio web para pedir más información."
                target="_blank" class="me-3 mb-4">
                <img class="iconRedes" [src]="'assets/ecommerce/WhatsApp_icon.png'" alt="">
            </a>
            <a href="http://m.me/111625762716231" target="_blank" class="me-3 mb-4">
                <img class="iconRedes"
                    src="https://images.vexels.com/media/users/3/223275/isolated/preview/fedc6cee8713c35480ad54ff5a4fbc0e-icono-de-mensajero-dise-o-plano.png"
                    alt="">
            </a>
        </div>
    </div>
</div>
<div class="col-12 position-relative floating-buttons" *ngIf="boolLogin && strAcceso == '1015'">
    <div class="position-absolute bottom-0 start-0 ms-3">
        <div class="d-flex flex-column ">
            <a href="https://api.whatsapp.com/send?phone=524792163410&amp; text=Hola, contacto desde el sitio web ecodeli partner para pedir más información."
                target="_blank" class="me-3 mb-4">
                <img class="iconRedes" [src]="'assets/ecommerce/WhatsApp_icon.png'" alt="">
            </a>
        </div>
    </div>
</div>
</div>
